import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsObjectService} from "../../../../../../core/shared/service/object/mvs-object.service";
import {ObjectRequestComplex} from "../../../../../../core/shared/dto/object/request/object-request-complex";
import {ObjectRequestComplexNode} from "../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../core/shared/dto/object/request/object-request-relation";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {CustomerService} from "../../../../service/api/customer.service";

@Component({
    selector: 'cr-customer-tickets',
    templateUrl: 'cr-customer-tickets.component.html',
    standalone: false
})
export class CrCustomerTicketsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() customerId: number;

  initialized: boolean;
  openTicketsWidget: WidgetData;
  broadcastSubscription: Subscription;
  disableUpdate: boolean = true;

  constructor(
    protected objectService: MvsObjectService,
    protected customerService: CustomerService) {
  }

  ngOnInit(): void {

    this.subscribeBroadcastChange();
    this.refreshOpenTickets();

    this.initialized = true;

  }


  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    this.refreshOpenTickets();

  }

  ngOnDestroy(): void {
    if (this.broadcastSubscription) {
      this.broadcastSubscription.unsubscribe();
    }
  }

  subscribeBroadcastChange() {
    this.broadcastSubscription = this.objectService.objectChangeEvent.subscribe(change => {
      this.openTicketsWidget = null;
      this.refreshOpenTickets();
    });
  }

  refreshOpenTickets() {
    const complexRequest = ObjectRequestComplex.build(
      true,
      false,
      ObjectRequestComplexNode.createRelationNode("tmTickets", ObjectRequestRelation.createJoin("+tmTickets")));

    const filter = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.customerId);

    const objectRequest = ObjectRequestList.createBasic(true, [filter], []);

    objectRequest.objectRequestComplex = complexRequest;

    this.customerService.list(objectRequest).subscribe(res => {

      const ticketList = res.entries[0].tmTickets ?? [];

      const filterCriteria = ticketList.length > 0 ?
        FilterCriteria.createOrFromArray('e.id', 'id', ticketList) :
        FilterCriteria.create('e.id', FilterCriteria.cOperatorEqual, 0);

      const objectRequestList = ObjectRequestList.createBasic(true, [filterCriteria], [new Sorting("createdDate", false)]);

      this.openTicketsWidget = WidgetFactory.createWidgetTableEntityQl(
        'cr.customer.list.open.tickets.transient.table.widget',
        "Tickets",
        'tm.Ticket',
        'No Ticket Found.',
        [filterCriteria]
      );
    });
  }
}
